export const baseURL = 'https://salonslotsaas.codderlab.com/';
// export const baseURL = 'http://192.168.1.45:5037/';
export const secretKey = 't03V6n2mIrMVsiQebrS17hxWc3yPSKNs';
export const projectName = 'Salon Slot';
